
import bulb from "../../../assets/images/bulb.svg";
import { MdOutlineArrowDownward } from "react-icons/md";

function Hero() {
  return (
    <section className="hero relative w-full bg-bg-black h-[100vh] flex items-end justify-center overflow-hidden pt-[115px] md:pt-[137px]">
      <div className="w-full flex flex-col items-center justify-center z-10 md:z-20 absolute md:bottom-[23%] bottom-[40%]">
        <h3 className="mx-auto font-bold text-white md:text-[60px] text-4xl md:w-[796px] w-[360px] text-center md:leading-[72px] leading-[44px] pb-6">
          <span className="opacity-50">An</span> innovative{" "}
          <span className="opacity-50">and</span> creative{" "}
          <span className="opacity-50">agency for modern day businesses</span>
        </h3>
        <h4 className="md:w-[728px] w-[78%] text-white leading-[28px] text-center md:text-[22px] text-base">
          At Protis, we develop eye-catching brands, build digital products, and
          deliver campaigns that stand out from the norm.
        </h4>
        <div className="my-10 hover:bg-white duration-300 text-white hover:text-black animate-bounce cursor-pointer h-[60px] w-[60px] md:h-[70px] md:w-[70px] bg-transparent border-2 border-white rounded-[50%] flex items-center justify-center">
          <MdOutlineArrowDownward size={30} />
        </div>
      </div>
      <div>
        <div className="inner-circle h-[600px] w-[600px] rounded-[50%] absolute bottom-[-25%] left-[50%] bg-[#191919] opacity-30 bg-noise"></div>
        <div className="outer-circle h-[1000px] w-[1000px] absolute bottom-[-60%] left-[50%] bg-[#111111] rounded-[50%] opacity-80"></div>
        <div className="hero-img-wrapper">
          <img
            src={bulb}
            alt=""
            className="pointer-events-none max-w-[250px]"
          />
        </div>
      </div>
    </section>
  );
}

export default Hero;
